import { jsx } from "react/jsx-runtime";
import { useMe } from "@crehana/auth";
import { useTranslation } from "@crehana/i18n";
import { Container } from "@crehana/ui";
import clsx from "clsx";
import { MAIN_FOOTER_PAGE_KEY } from "./constants.js";
import localeEn from "./i18n/localeEn.js";
import localeEs from "./i18n/localeEs.js";
import localePt from "./i18n/localePt.js";
import BottomSection from "./sections/BottomSection/index.js";
const TRANSLATIONS = {
    es: {
        [MAIN_FOOTER_PAGE_KEY]: localeEs.es
    },
    pt: {
        [MAIN_FOOTER_PAGE_KEY]: localePt.pt
    },
    en: {
        [MAIN_FOOTER_PAGE_KEY]: localeEn.en
    }
};
const MainFooter = ({ isDark, className, ignoreBgTransparent = false, containerType, layouts, shouldHideAppsColumn = false })=>{
    const { me } = useMe();
    const { addResourceBundle } = useTranslation();
    const shouldHideCurrencySelector = 'boolean' == typeof layouts?.shouldHideCurrencySelector ? layouts.shouldHideCurrencySelector : !!me?.isB2B;
    addResourceBundle(TRANSLATIONS);
    return /*#__PURE__*/ jsx("footer", {
        id: "main-footer",
        className: clsx('tw-pt-3.2 sm:tw-pt-4.8 lg:tw-pt-6.4', {
            'bg-base-main-80': isDark,
            'tw-bg-transparent': !isDark && !ignoreBgTransparent
        }, className),
        children: /*#__PURE__*/ jsx(Container, {
            type: containerType,
            children: /*#__PURE__*/ jsx(BottomSection, {
                isDark: isDark,
                shouldHideCurrencySelector: shouldHideCurrencySelector,
                shouldHideAppsColumn: shouldHideAppsColumn
            })
        })
    });
};
const MainFooter_MainFooter = MainFooter;
export default MainFooter_MainFooter;
